<template>
  <div class="column">
    <p v-if="label" class="refine-search-multi-checkbox-button__label font-nunito text-weight-bolder primary-text">{{ label }}</p>
    <div class="row q-col-gutter-sm">
      <div v-for="(option, index) in options" :key="index" :class="optionColClass">
        <CheckboxButton
          v-model="selectedOptions[option.value]"
          :label="option.label"
          :value="option.value"
          fullWidth
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxButton from '../CheckboxButton';

export default {
  name: 'RefineSearchMultiCheckboxButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.every((opt) => 'id' in opt && 'label' in opt)
    },
    value: {
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidthOnMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    optionColClass() {
      return this.fullWidthOnMobile ? 'col-12 col-sm-6' : 'col-6';
    }
  },
  data() {
    return {
      selectedOptions: this.value
    };
  },
  watch: {
    value(newValue) {
      this.selectedOptions = newValue;
    },
    selectedOptions(newSelectedOptions) {
      this.$emit('input', newSelectedOptions);
    }
  },
  components: { CheckboxButton }
};
</script>

<style lang="sass" scoped>
@import '../../../styles/calculator/vehicle-result-page-breakpoints'
@import '../../../styles/calculator/refine-embedded'

@media (max-width: $vr-phone-toolbar-max)
  .refine-search-multi-checkbox-button__label
    +refine-embedded-section-label-bold
</style>
